{
	"ariaChangeAIStyleCoverImage": "Change AI Style Cover Image",
	"ariaUserStyleMenu": "user_style_menu",
	"changeCover": "Change cover",
	"changeCoverTitle": "Change AI Style cover",
	"coverUpdated": "Cover updated successfully.",
	"deleteAIStyle": "Delete AI Style",
	"deleteMessage": "Existing projects that use {{name}} will remain unchanged. This action cannot be undone. Do you want to proceed?",
	"deleteTitle": "Delete AI Style",
	"duplicateAIStyle": "Duplicate AI Style",
	"duplicateTitle": "Duplicate AI Style",
	"duplicating": "Duplicating AI Style...",
	"duplicated": "AI Style duplicated successfully",
	"renameAIStyle": "Rename AI Style",
	"renameTitle": "Rename AI Style",
	"renaming": "Renaming AI Style...",
	"renamed": "AI Style renamed successfully",
	"updatingCover": "Updating cover...",
	"viewReferences": "View References"
}
